import { Ellipse, Point } from 'src/types/transforms';

export const createEllipse = (): Ellipse => ({
    center: { x: 0, y: 0 },
    radiusX: 0,
    radiusY: 0,
    rotationDegrees: 0,
});

export const pointAtAngle = (ellipse: Ellipse, angleInRadians: number): Point => {
    // Compute points on ellipse without rotation
    const x = ellipse.radiusX * Math.cos(angleInRadians);
    const y = ellipse.radiusY * Math.sin(angleInRadians);

    const rotationRadians = (ellipse.rotationDegrees * Math.PI) / 180;

    // Return points rotated based on ellipse rotation and translated based on ellipse center
    return {
        x: ellipse.center.x + x * Math.cos(rotationRadians) - y * Math.sin(rotationRadians),
        y: ellipse.center.y + y * Math.cos(rotationRadians) + x * Math.sin(rotationRadians),
    };
};
